import styled, { css } from 'styled-components'

import { Button } from '@/components/business/market-shop/button'
import { BorderLoader } from '@/components/ui/loaders/border-loader'

export const Root = styled.div<{ $empty?: boolean }>(
  ({ theme, $empty }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${theme.colors.gray100};
    overflow: hidden;
    padding: ${$empty ? theme.space['16'] : 'unset'};
  `,
)

export const RootLoader = styled(BorderLoader)`
  margin: auto;
`

export const ErrorContainer = styled.div(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;

    & > [data-component-id='Alert'] {
      align-self: center;
    }
  `,
)

export const ShoppingCartButton = styled(Button)(
  ({ theme }) => css`
    position: fixed;
    inset: auto ${theme.space['16']} ${theme.space['16']};
    z-index: ${theme.zIndex.level1};
  `,
)
